import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { IPassportGroup, IPassportSchema, TCreatePassportGroupDTO } from '@/pages/MDM/mdm.types.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import PassportGroupDropdown from '@/pages/MDM/components/Passports/PassportGroupDropdown'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { useEffect } from 'react'

interface IProps {
  initialGroupId: IPassportGroup['id']
  passportId: IPassportSchema['id']
  open: boolean
  onClose: () => void
}

const CreatePassportGroupModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [group, setGroup, handleChange] = useStateWithChange<TCreatePassportGroupDTO>({
    name: '',
    parentId: props.initialGroupId ?? null,
    passportSchemaId: props.initialGroupId,
  })

  useEffect(() => {
    setGroup({
      name: '',
      parentId: props.initialGroupId ?? null,
      passportSchemaId: props.initialGroupId,
    })
  }, [props.initialGroupId])

  const handleSave = () => {
    wait(mdmApi.createPassportSchemaGroup({ ...group, passportSchemaId: props.passportId }), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.passportSchemaGroupCreated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Создание группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <PassportGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={group.parentId}
            passportSchemaId={props.passportId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={group.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default CreatePassportGroupModal
